// extracted by mini-css-extract-plugin
export default {"pill":"Pill_pill__avKya","dot":"Pill_dot__HKfFu","pulse":"Pill_pulse__wWU0x","hvPulse":"Pill_hvPulse__4mW9Y"};